import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import LinkPanel from './LinkPanel';

import integrationImage from '../assets/integration.svg';
import signupTrialImage from '../assets/sign-up.svg';

const SetupNwc = (props) => {
    const { t } = useTranslation();

    return (
        <>
            <p>{t('onBoardNwc2.thankYou')}</p>
            <div className={cn('ntx-modal-body-row ntx-modal-body-row-navigate-options')}>
                <LinkPanel 
                    className="first-block"
                    onClick={props.onNavigateToNwcIntegration}
                    image={integrationImage}
                    alt={t('onBoardNwc2.integrateExistingTenant')}
                    caption={t('onBoardNwc2.integrateExistingTenant')}
                    description={t('onBoardNwc2.integrateExistingTenantDescription')}
                />
                <LinkPanel 
                    className="second-block"
                    onClick={props.onNavigateToNwcTrial}
                    image={signupTrialImage}
                    alt={t('onBoardNwc2.signupFreeTrial')}
                    caption={t('onBoardNwc2.signupFreeTrial')}
                    description={t('onBoardNwc2.signupFreeTrialDescription')}
                />
            </div>
        </>
    );
};

export default SetupNwc;